import { render, staticRenderFns } from "./compCase.vue?vue&type=template&id=94e18be4&"
import script from "./compCase.vue?vue&type=script&lang=js&"
export * from "./compCase.vue?vue&type=script&lang=js&"
import style0 from "./compCase.vue?vue&type=style&index=0&id=94e18be4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports